import {
  Component,
  input,
  effect,
  ElementRef,
  inject,
  viewChild,
} from '@angular/core';
import { ScriptInjectorService } from '../script-injector.service';

@Component({
  selector: 'hsuc-safe-script',
  imports: [],
  template: `<span #scriptTarget></span>`,
  styles: `
    :host {
      display: inline-block;
      font-size: 1.0rem; /* Equivalent to text-lg (18px) */
      line-height: 1.75rem;
    }
  `
})
export class SafeScriptComponent {
  scriptCode = input<string>();
  scriptTarget = viewChild.required<ElementRef<HTMLDivElement>>('scriptTarget');
  scriptInjector = inject(ScriptInjectorService);
  constructor() {
    effect(() => {
      if (!this.scriptTarget()) {
        return;
      }
      this.scriptTarget().nativeElement.innerHTML = '';
      const fragment = document
        .createRange()
        .createContextualFragment(this.scriptCode() ?? '');
      this.scriptTarget().nativeElement.appendChild(fragment);
    });
  }

}
